import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import '../Buttons/buttonThemes.stylex';
import { buttonSizes } from '../Buttons/buttonThemes.stylex';
import * as icons from './ui-icons';
export interface UiIconProps {
  icon: keyof typeof icons;
  size?: keyof typeof iconSizes;
  styles?: stylex.StyleXStyles;
}
export const UiIcon = forwardRef<SVGSVGElement, UiIconProps>(function UiIcon({
  icon,
  size = 'regular',
  styles
}: UiIconProps, ref) {
  const Icon = icons[icon];
  return <Icon size={iconSizes[size]} styles={[opticalAdjustments[icon as keyof typeof opticalAdjustments], styles]} ref={ref} />;
});
const iconSizes = {
  regular: {
    kZKoxP: "xwcisui",
    kzqmXN: "xwdhrc6",
    $$css: true
  }
};
const opticalAdjustments = {
  Play: {
    k3aq6I: "x1nouqcy",
    $$css: true
  },
  Chevron: {
    k3aq6I: "x1ni14s7",
    $$css: true
  }
};